// @ts-nocheck
import * as React from "react";

const BoxReturnFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M13.542 11.656A6.5 6.5 0 0 0 19 12.824V17.1a1.69 1.69 0 0 1-1 1.51L10.8 22h-.05v-9.17l2.792-1.174ZM1 9.36l8.25 3.47V22h-.06L2 18.61a1.69 1.69 0 0 1-1-1.52V9.36Zm9.8-5.18.538.252a6.498 6.498 0 0 0 1.04 6.07L10 11.5 1.49 7.93A1.62 1.62 0 0 1 2 7.55l7.2-3.37a1.87 1.87 0 0 1 1.6 0Zm4.773-.65c.232.072.412.26.48.498a.757.757 0 0 1-.148.691l-.486.513h4.2c.896 0 1.727.464 2.222 1.227l.101.168c.477.86.477 1.919 0 2.779A2.664 2.664 0 0 1 19.62 10.8h-2.53a.709.709 0 0 1-.619-.37.756.756 0 0 1 0-.73.709.709 0 0 1 .618-.37h2.53c.448 0 .862-.25 1.087-.655.226-.407.226-.91 0-1.317a1.247 1.247 0 0 0-1.086-.655h-4.198l.556.58a.75.75 0 0 1-.042.988.697.697 0 0 1-1.041-.033L13.21 6.481a.747.747 0 0 1-.209-.52c0-.195.075-.382.208-.52l1.695-1.763a.696.696 0 0 1 .67-.148Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BoxReturnFill);
